import React from 'react';
import { string } from 'prop-types';

const UserWithAvatarLabel = ({ username = '', avatarUrl = '' }) => (
  <div className="tickets-index-page__user-with-avatar-label">
    <img
      src={avatarUrl}
      alt={username}
    />
    <span>{username}</span>
  </div>
);

UserWithAvatarLabel.propTypes = {
  username: string,
  avatarUrl: string,
};

export default UserWithAvatarLabel;
